<template>
  <div>
    <span v-if="!interview.questions || !interview.questions.length">{{ `app.no_data` | trans }}</span>
    <div v-for="(question, index) in questions">
      <h5 v-bind:class="{'mt-4':index !== 0}" class="subheading">{{ question.text }}</h5>
      <p>{{ question.answer }}</p>
    </div>
  </div>
</template>
<script>
import { mapGetters} from "vuex";

export default {
  computed: {
    ...mapGetters(['interview']),
    questions: function () {
      if (this.interview.questions === null) {
        return [];
      }
      return this.interview.questions.sort((questionA, questionB) => {
        return questionA.order - questionB.order;
      });
    },
  }
}
</script>